import React from 'react';
import Header from 'components/Header/Header';
import Footer from 'components/Footer';
import PasswordRecovery from '../components/PasswordRecovery';
import DefaultDescription from '../components/DefaultDescription/DefaultDescription';
import passwordStyles from './login.module.scss';

function passwordRecovery() {
  return (
    <>
      <Header />
      <div className={passwordStyles.background}>
        <div className={passwordStyles.background__overlay}>
          <div className={passwordStyles.body__content}>
            <div
              className={passwordStyles.description__container}
            >
              <DefaultDescription />
            </div>
            <div
              className={passwordStyles.form__container}
              style={{ padding: '10px 0' }}
            >
              <PasswordRecovery />
            </div>
          </div>
        </div>
      </div>
      <div className={passwordStyles.footer__container}>
        <Footer />
      </div>
    </>
  );
}

passwordRecovery.propTypes = {};

export default passwordRecovery;
